import { c as _c } from "react/compiler-runtime";
import { StarRating } from '@/components/StarRating';
import { Typography } from '@/components/Typography';
import type { CmsFleetCategory } from '@/services/cms-sdk';
export type FleetCategoryStarRatingProps = {
  rating: CmsFleetCategory['rating'];
};
export function FleetCategoryStarRating(t0) {
  const $ = _c(7);
  const {
    rating
  } = t0;
  if (!rating?.count) {
    return null;
  }
  let t1;
  if ($[0] !== rating.average) {
    t1 = <StarRating className="text-primary" max={5} value={rating.average} />;
    $[0] = rating.average;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== rating.count) {
    t2 = <Typography variant="caption">({rating.count})</Typography>;
    $[2] = rating.count;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-row gap-2 items-center h-5">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}